import { getLang } from '../i18n/LanguageContext';

export { fmtNum, fmtPct, fmtEuro, fmtDate, fmtDateTime } from './kernelFormat';

// Formato fisso DD-MM-YYYY (a differenza di fmtDate, che segue il formato
// nativo del browser/locale, es. DD/MM/YYYY) - richiesto per la colonna
// "Creato il" della lista ticket.
export const fmtDateDMY = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d)) return String(value);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  return `${day}-${month}-${d.getFullYear()}`;
};

const MONTHS_IT = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
const MONTHS_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Data relativa (Oggi/Ieri/Domani, altrimenti "16 set") - solo la data, senza
// orario: usata per la scadenza dei ticket, che nel nostro form è solo un
// giorno (niente ora), quindi mostrare "00:00" sarebbe fuorviante.
export const fmtRelativeDate = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d)) return String(value);
  const startOfDay = (dt) => new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  const diffDays = Math.round((startOfDay(d) - startOfDay(new Date())) / 86400000);
  const en = getLang() === 'en-GB';
  if (diffDays === 0) return en ? 'Today' : 'Oggi';
  if (diffDays === -1) return en ? 'Yesterday' : 'Ieri';
  if (diffDays === 1) return en ? 'Tomorrow' : 'Domani';
  const months = en ? MONTHS_EN : MONTHS_IT;
  return `${d.getDate()} ${months[d.getMonth()]}`;
};
